<!--====== PAGE TITLE PART START ======-->
<div class="page-title-area">
  <div class="banner-overlay2"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="page-title-item text-center">
                    <h2 class="title">Page non trouvé</h2>
                </div> <!-- page title -->
            </div>
        </div> <!-- row -->
    </div> <!-- container -->
</div>
<!--====== PAGE TITLE PART ENDS ======-->
<!--====== ERROR PART START ======-->
<div class="error-area pt-120 pb-115">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="error-item text-center">
                    <h2 class="title">La page que vous cherchez<br> n'existe pas</h2>
                    <span>.</span>
                </div> <!-- error item -->
            </div>
        </div>
    </div>
</div>
<!--====== ERROR PART ENDS ======-->
<app-footer></app-footer>
